import { AddressInputFieldsFragment } from '@/types';
import { AddressInputType } from '@domain/addresses/types/types';

/**
 * Converts a {@link AddressInputFieldsFragment} into the
 * {@link AddressInputType} shape used by form components.
 *
 * @param address - The raw address fragment returned from a GraphQL query.
 * @returns An {@link AddressInputType}.
 */
export const formatAddressForInput = (
  address: AddressInputFieldsFragment,
): AddressInputType => {
  return {
    address: address.address,
    address2: address.address2 || '',
    city: address.city,
    countryCode: address.country_code,
    latitude: address.latitude,
    longitude: address.longitude,
    region: address.region || '',
  };
};
